class QuickBuy extends HTMLElement {
  constructor() {
    super();
  }

  selectors = {
    form: {
      container: "[data-product-form]"
    }
  };

  async connectedCallback() {
    this.product = await this.initProduct();

    if (!Object.keys(this.product).length) {
      return;
    }

    this.initElements();
    this.initProductForm();
  }

  get productHandle() {
    return this.getAttribute("handle");
  }

  async initProduct() {
    if (!this.productHandle) {
      return {};
    }

    const url = `/products/${this.productHandle}.js`;

    const response = await fetch(url).then(
      (data) => data.text()
    );

    return JSON.parse(response);
  }

  initElements() {
    this.productFormElement = this.querySelector(this.selectors.form.container);
  }

  initProductForm() {
    if (!this.productFormElement) {
      return null;
    }

    this.productForm = new Shopify.theme.productForm.ProductForm(
      this.productFormElement,
      this.product,
      {
        onOptionChange: this.onOptionChange.bind(this),
        onFormSubmit: () => {},
        onQuantityChange: () => {},
        onPropertyChange: () => {}
      }
    );
  }

  onOptionChange(event) {
    const variant = event.dataset.variant;

    if (!variant.available) {
      return;
    }

    this.onVariantAdd(variant);
  }

  async onVariantAdd(variant) {
    if (!variant) {
      return;
    }

    const url = `${window.theme.routes.cart}/add.js`;

    try {
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({
          items: [{
            id: variant.id,
            quantity: 1
          }]
        }),
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      const data = await response.json();

      const { status, description } = data;

      if (status === 422) {
        this.onVariantAddedError(description);
        return;
      }

      this.onVariantAddedSuccess(data, variant);
    } catch (error) {
      this.onVariantAddedError(error);
    }
  }

  onVariantAddedSuccess(data, variant) {
    document.dispatchEvent(new CustomEvent("theme:cart:popdown", {
      detail: {
        variant
      }
    }));

    this.updateCart();
  }

  onVariantAddedError(error) {
    console.error(error);
  }

  async updateCart() {
    const url = `${Shopify.routes.root}cart.js`;

    const response = await fetch(url).then(
      (data) => data.json()
    );

    document.dispatchEvent(new CustomEvent("theme:cart:change", {
      detail: {
        cart: response
      },
      bubbles: true
    }));
  }
}

if (!customElements.get("quick-buy")) {
  customElements.define("quick-buy", QuickBuy);
}
